import React, { useEffect, useState } from "react";
import Moment from "react-moment";
import { useNavigate } from "react-router-dom";
import { getFieldData, getFormatedNumber } from "../../../Services/appService";
import { getCurrentUser } from "../../store/auth";
import { getAppTasks, getCandidateApps, loadAppRuningTasks, loadCandidateApps } from "../../store/candidate";
import { useDispatch, useSelector } from "react-redux";
import TimerPopup from "../../../Components/TimerPopup";
import AppMessages from "../../../Components/AppMessages";
import { setCurrentPageTitle, setCurrentRoute } from "../../store/layoutUI";
import { OverlayTrigger, Popover } from "react-bootstrap";

const ONBOARDING_STATUS_STYLES = {
    card: {
        borderRadius: "22px",
        border: "1px solid rgba(226, 232, 240, 1)",
        background: "linear-gradient(180deg, #ffffff 0%, #fbfdff 100%)",
        boxShadow: "0 14px 34px rgba(15, 23, 42, 0.05)",
        overflow: "hidden"
    },
    cardHeader: {
        padding: "20px 22px 16px 22px",
        borderBottom: "1px solid rgba(226, 232, 240, 1)",
        background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)"
    },
    headerRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "16px",
        flexWrap: "wrap"
    },
    headerCopy: {
        minWidth: "240px",
        flex: "1 1 420px"
    },
    headerActions: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end"
    },
    title: {
        fontSize: "18px",
        fontWeight: 800,
        color: "#0f172a",
        lineHeight: 1.25,
        margin: 0
    },
    titleRow: {
        display: "flex",
        alignItems: "flex-start",
        gap: "12px"
    },
    titleIcon: {
        width: "34px",
        height: "34px",
        borderRadius: "10px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#eef2ff",
        color: "#4f46e5",
        fontSize: "15px",
        border: "1px solid rgba(224, 231, 255, 1)",
        flexShrink: 0
    },
    titleText: {
        display: "flex",
        flexDirection: "column",
        gap: "4px",
        minWidth: 0
    },
    subtitle: {
        fontSize: "13px",
        lineHeight: 1.5,
        color: "#64748b",
        margin: 0
    },
    cardBody: {
        padding: "18px 22px 22px 22px"
    },
    utilityRow: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: "12px",
        flexWrap: "wrap",
        marginBottom: "14px"
    },
    refreshButton: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        borderRadius: "999px",
        border: "1px solid rgba(226, 232, 240, 1)",
        background: "#ffffff",
        color: "#334155",
        padding: "7px 12px",
        fontSize: "12px",
        fontWeight: 700
    },
    tableWrap: {
        border: "1px solid rgba(226, 232, 240, 1)",
        borderRadius: "18px",
        overflow: "auto",
        backgroundColor: "#ffffff",
        boxShadow: "0 12px 28px rgba(15, 23, 42, 0.05)"
    },
    table: {
        marginBottom: 0
    },
    tableHeadCell: {
        borderTop: "none",
        fontSize: "12px",
        fontWeight: 800,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        color: "#64748b",
        background: "#f8fafc",
        padding: "14px 16px"
    },
    cell: {
        verticalAlign: "middle",
        padding: "18px 16px",
        borderTop: "1px solid rgba(241, 245, 249, 1)",
        background: "#ffffff"
    },
    idValue: {
        fontSize: "15px",
        fontWeight: 700,
        color: "#0f172a"
    },
    datePrimary: {
        fontSize: "14px",
        fontWeight: 700,
        color: "#0f172a",
        marginBottom: "4px"
    },
    dateSecondary: {
        fontSize: "12px",
        color: "#64748b"
    },
    personName: {
        fontSize: "14px",
        fontWeight: 700,
        color: "#0f172a",
        marginBottom: "4px"
    },
    personMeta: {
        fontSize: "12px",
        lineHeight: 1.55,
        color: "#64748b"
    },
    actionStack: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "8px"
    },
    primaryAction: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        borderRadius: "999px",
        border: "1px solid rgba(191, 219, 254, 1)",
        background: "#eff6ff",
        color: "#1d4ed8",
        padding: "7px 12px",
        fontSize: "12px",
        fontWeight: 700
    },
    secondaryAction: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        borderRadius: "999px",
        border: "1px solid rgba(226, 232, 240, 1)",
        background: "#ffffff",
        color: "#334155",
        padding: "7px 12px",
        fontSize: "12px",
        fontWeight: 700
    },
    statusPillBase: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        padding: "6px 10px",
        borderRadius: "999px",
        fontSize: "12px",
        fontWeight: 700,
        border: "1px solid transparent"
    },
    messageButton: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        borderRadius: "999px",
        border: "1px solid rgba(226, 232, 240, 1)",
        background: "#ffffff",
        color: "#334155",
        padding: "7px 12px",
        fontSize: "12px",
        fontWeight: 700,
        position: "relative"
    },
    noteButton: {
        border: "none",
        background: "transparent",
        color: "#2563eb",
        padding: 0,
        fontSize: "12px",
        fontWeight: 700
    }
};

export default function OnboardingStatus() {

    const usrType = localStorage.getItem("userType");
    const [entityType, setEntityType] = useState("");
    const [appTasklist, setAppTasklist] = useState([]);
    const [appSubmitStatus, setAppSubmitStatus] = useState(false);
    const [timerShowHide, setTimerShowHide] = useState(false);
    const [msgShowHide, setMsgShowHide] = useState(false);
    const [wfId, setWfId] = useState(0);
    const [currentApp, setCurrentApp] = useState("");

    const candidateAppsSelector = useSelector(getCandidateApps);
    const appTasksSelector = useSelector(getAppTasks);

    const dispatch = useDispatch();
    const currentUser = getCurrentUser();
    const navigate = useNavigate();

    const route = [
        { name: "Task Management", url: "" },
        { name: "Onboarding", url: "" },
    ];
    const route1 = [
        { name: "Contract Management", url: "" },
        { name: "Onboarding", url: "" },
    ];

    let appType = "Onboarding";
    if (usrType === "candidate")
        appType = "Onboarding";

    let count = entityType !== "C2C Basis" ? "6" : "5";

    if (usrType !== "candidate")
        count = "5";


    useEffect(() => {
        dispatch(setCurrentPageTitle(`STEP-${count} : ${appType}`));
        dispatch(setCurrentRoute(usrType === "candidate" ? route : route1))
    }, [])

    useEffect(() => {
        let usrId = currentUser.id;
        if (currentUser.linkUser)
            usrId = currentUser.linkUser;
        if (candidateAppsSelector.length === 0 && currentUser?.id > 0)
            dispatch(loadCandidateApps(usrId))
    }, []);

    useEffect(() => {
        if (candidateAppsSelector.length > 0 && currentUser?.id > 0) {
            const mainWorkflow = candidateAppsSelector.filter(x => x.workflowType === 1);
            if (mainWorkflow.length > 0) {
                const wf = mainWorkflow[0];
                setWfId(wf.oldWorkflowId);
                let usrId = currentUser.id;
                if (currentUser.linkUser)
                    usrId = currentUser.linkUser;
                if (appTasksSelector.length === 0 && currentUser?.id > 0)
                    dispatch(loadAppRuningTasks(wf.oldWorkflowId, usrId));
            }
        }
    }, [candidateAppsSelector]);

    useEffect(() => {
        if (appTasksSelector.length > 0) {
            const filterTasks = appTasksSelector.filter(x => x.taskType === 1 && x.wiid > 0
                && (x.wfPhase === "Review" || x.wfPhase === "Approved" || x.wfPhase === "Rejected"));
            let firstAppTasks = [];
            if (filterTasks.length > 0) {
                firstAppTasks = [filterTasks[filterTasks.length - 1]];
                setAppTasklist(firstAppTasks);
                setAppSubmitStatus(filterTasks[0].appSubmit);
            }
        }
    }, [appTasksSelector]);

    const handleViewAppSummary = (item, type) => {
        navigate("/ApplicationSummary", { state: { task: item, viewType: type } });
    }

    const handleRefresh = () => {
        let usrId = currentUser.id;
        if (currentUser.linkUser) usrId = currentUser.linkUser;
        if (usrId > 0) dispatch(loadCandidateApps(usrId));
        if (wfId > 0 && usrId > 0) dispatch(loadAppRuningTasks(wfId, usrId));
    };

    const handleCurrentTask = () => {
        // const { data: workflowTask } = await http.get(
        //     config.GetWorkflowTask + wiid
        //   );
        //   if (workflowTask.formId > 0) {
        //     if (workflowTask.formType === "CF") {
        //       this.props.history.push({
        //         pathname: "/" + workflowTask.formName,
        //         state: { workflowTask },
        //       });
        //     } else {
        //       this.props.history.push({
        //         pathname: "/DynamicForm",
        //         state: { workflowTask },
        //       });
        //     }
        //   }
    }

    const handleTimerModalShowHide = () => {
        setTimerShowHide(!timerShowHide);
    };

    const handleMsgShowHide = (app) => {
        setMsgShowHide(!msgShowHide);
        setCurrentApp(app);
    };

    function formatCustomDate(dateString) {
        const date = new Date(dateString);
        const day = date.getDate();
        const suffix = ["th", "st", "nd", "rd"][(day % 10 > 3 || [11, 12, 13].includes(day)) ? 0 : day % 10];

        return date.toLocaleString("en-US", {
            month: "short",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "numeric",
            hour12: true
        }).replace(/\b\d{1,2}\b/, day + suffix);
    }

    const getPopover = (notes) => {
        const popover = (
            <Popover id="popover-basic">
                <Popover.Title as="h4">Notification</Popover.Title>
                <Popover.Content>{notes}</Popover.Content>
            </Popover>
        );
        return (
            <OverlayTrigger trigger="click" placement="top" overlay={popover}>
                <button className="btn btn-sm" style={ONBOARDING_STATUS_STYLES.noteButton}>Notification</button>
            </OverlayTrigger>
        );
    };

    const getStatusPillStyle = (wfPhase) => {
        if (wfPhase === "Approved") {
            return {
                ...ONBOARDING_STATUS_STYLES.statusPillBase,
                color: "#166534",
                backgroundColor: "#f0fdf4",
                borderColor: "rgba(187, 247, 208, 1)"
            };
        }

        if (wfPhase === "Rejected") {
            return {
                ...ONBOARDING_STATUS_STYLES.statusPillBase,
                color: "#b91c1c",
                backgroundColor: "#fef2f2",
                borderColor: "rgba(254, 202, 202, 1)"
            };
        }

        return {
            ...ONBOARDING_STATUS_STYLES.statusPillBase,
            color: "#92400e",
            backgroundColor: "#fffbeb",
            borderColor: "rgba(253, 230, 138, 1)"
        };
    };

    const renderReviewerDetails = (name, role, extra, email, contact, time) => (
        <>
            {name && <div style={ONBOARDING_STATUS_STYLES.personName}>{name.toUpperCase()}</div>}
            {(role || extra) && (
                <div style={ONBOARDING_STATUS_STYLES.personMeta}>
                    {role} {extra}
                </div>
            )}
            {email && <div style={ONBOARDING_STATUS_STYLES.personMeta}>{email}</div>}
            {contact && <div style={ONBOARDING_STATUS_STYLES.personMeta}>{getFormatedNumber(contact)}</div>}
            {time && <div style={ONBOARDING_STATUS_STYLES.personMeta}>{formatCustomDate(time)}</div>}
        </>
    );


    return <React.Fragment>

        <div className="mt-2 form-group">
            <style>{`
                .onboarding-status-table tbody tr:hover td {
                    background-color: #f8fbff !important;
                }

                @media (max-width: 991.98px) {
                    .onboarding-status-table {
                        min-width: 1100px;
                    }
                }
            `}</style>
            <div className="card shadow-none border-1" style={ONBOARDING_STATUS_STYLES.card}>
                <div className="card-header border-1" style={ONBOARDING_STATUS_STYLES.cardHeader}>
                    <div style={ONBOARDING_STATUS_STYLES.headerRow}>
                        <div style={ONBOARDING_STATUS_STYLES.headerCopy}>
                            <div style={ONBOARDING_STATUS_STYLES.titleRow}>
                                <span style={ONBOARDING_STATUS_STYLES.titleIcon}>
                                    <i className="fa fa-clipboard" aria-hidden="true"></i>
                                </span>
                                <div style={ONBOARDING_STATUS_STYLES.titleText}>
                                    <div style={ONBOARDING_STATUS_STYLES.title}>Check Onboarding Status</div>
                                    <p style={ONBOARDING_STATUS_STYLES.subtitle}>
                                        Review the latest onboarding decision, assigned reviewers, notifications, and conversation updates in one place.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div style={ONBOARDING_STATUS_STYLES.headerActions}>
                            <button
                                className="btn btn-sm"
                                style={ONBOARDING_STATUS_STYLES.refreshButton}
                                onClick={handleRefresh}
                            >
                                <i className="fa fa-refresh" aria-hidden="true"></i>
                                Refresh
                            </button>
                        </div>
                    </div>
                </div>
                <div className="card-body border-1" style={ONBOARDING_STATUS_STYLES.cardBody}>
                    <div className="table-responsive" style={ONBOARDING_STATUS_STYLES.tableWrap}>
                        <table className="table align-items-center table-hover mb-0 onboarding-status-table" style={ONBOARDING_STATUS_STYLES.table}>
                            <thead>
                                <tr>
                                    <th style={ONBOARDING_STATUS_STYLES.tableHeadCell}>ID</th>
                                    <th style={ONBOARDING_STATUS_STYLES.tableHeadCell}>Date & Time<br />Submitted</th>
                                    <th style={ONBOARDING_STATUS_STYLES.tableHeadCell}>{appType} Form</th>
                                    <th style={ONBOARDING_STATUS_STYLES.tableHeadCell}>Reviewer Assigned</th>
                                    <th style={ONBOARDING_STATUS_STYLES.tableHeadCell}>Reviewer Re-Assigned</th>
                                    <th style={ONBOARDING_STATUS_STYLES.tableHeadCell}>Status</th>
                                    <th style={ONBOARDING_STATUS_STYLES.tableHeadCell}>Messages</th>
                                    {/* {
                                        usrType !== "candidate" &&
                                        <th>Alerts</th>
                                    } */}
                                </tr>
                            </thead>
                            <tbody>
                                {appTasklist.map((item, key) =>
                                    <tr key={item.wiid || key}>
                                        <td style={ONBOARDING_STATUS_STYLES.cell}>
                                            <div style={ONBOARDING_STATUS_STYLES.idValue}>{item.ciid}</div>
                                        </td>
                                        <td style={ONBOARDING_STATUS_STYLES.cell}>
                                            <div style={ONBOARDING_STATUS_STYLES.datePrimary}>
                                                <Moment format="MMM Do YYYY">
                                                    {item.startDateTime}
                                                </Moment>
                                            </div>
                                            <div style={ONBOARDING_STATUS_STYLES.dateSecondary}>
                                                <Moment format="h:mm a">
                                                    {item.startDateTime}
                                                </Moment>
                                            </div>
                                        </td>
                                        <td style={ONBOARDING_STATUS_STYLES.cell}>
                                            <div style={ONBOARDING_STATUS_STYLES.actionStack}>
                                                <button
                                                    onClick={() => handleViewAppSummary(item, "view")}
                                                    className="btn btn-sm border-0"
                                                    style={ONBOARDING_STATUS_STYLES.primaryAction}
                                                >
                                                    <i className="fa fa-eye" aria-hidden="true"></i>
                                                    View
                                                </button>
                                                <button
                                                    onClick={() => handleViewAppSummary(item, "edit")}
                                                    className="btn btn-sm border-0"
                                                    style={ONBOARDING_STATUS_STYLES.secondaryAction}
                                                >
                                                    <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
                                                    Edit/Update
                                                </button>
                                            </div>
                                        </td>
                                        <td style={ONBOARDING_STATUS_STYLES.cell}>
                                            {item.reassignById > 0 ? <>
                                                {renderReviewerDetails(
                                                    item.reassignByName,
                                                    item.reassignByRole,
                                                    item.reassignByRegistrationType !== "WP" &&
                                                    item.reassignByRegistrationType !== "PP" &&
                                                    item.reassignByRegistrationType,
                                                    item.reassignByEmail,
                                                    item.reassignByContact
                                                )}
                                            </> : <>
                                                {item.performerId !== parseInt(currentUser.id) && <>
                                                    {renderReviewerDetails(
                                                        item.performer,
                                                        item.role,
                                                        `${item.partner || ""} ${item.registrationType !== "WP" &&
                                                            item.registrationType !== "PP" &&
                                                            item.registrationType ? item.registrationType : ""}`.trim(),
                                                        item.email,
                                                        item.contact
                                                    )}
                                                </>}
                                            </>}
                                        </td>
                                        <td style={ONBOARDING_STATUS_STYLES.cell}>
                                            {item.reassignById > 0 && item.performerId !== parseInt(currentUser.id) && <>
                                                {renderReviewerDetails(
                                                    item.performer,
                                                    item.role,
                                                    `${item.partner || ""} ${item.registrationType !== "WP" &&
                                                        item.registrationType !== "PP" &&
                                                        item.registrationType ? item.registrationType : ""}`.trim(),
                                                    item.email,
                                                    item.contact,
                                                    item.reassignDateTime
                                                )}
                                            </>}
                                        </td>
                                        <td style={{ ...ONBOARDING_STATUS_STYLES.cell, whiteSpace: "pre-wrap" }}>
                                            {item.performerId === parseInt(currentUser.id) ?
                                                <button
                                                    className="btn btn-sm border-0"
                                                    style={ONBOARDING_STATUS_STYLES.primaryAction}
                                                    onClick={() => handleCurrentTask(item.wiid)}
                                                >
                                                    <i className="fa fa-play-circle" aria-hidden="true"></i>
                                                    {item.wfPhase}
                                                </button> : <span style={getStatusPillStyle(item.wfPhase)}>{item.wfPhase === "Approved" && <i
                                                    className="fa fa-check"
                                                    style={{ fontSize: "13px" }}
                                                    aria-hidden="true"
                                                ></i>} {item.wfPhase}</span>}
                                            <br />
                                            {usrType !== "candidate" && getPopover(getFieldData(item.stateData, "contractdocuments", "Notification_Notes"))}
                                        </td>
                                        <td style={ONBOARDING_STATUS_STYLES.cell}>
                                            {item.taskDoneStatus !== 0 && item.wfPhase !== "Application" && (
                                                <button
                                                    className="btn btn-sm border-0"
                                                    style={ONBOARDING_STATUS_STYLES.messageButton}
                                                    onClick={() => handleMsgShowHide(item)
                                                    }
                                                >
                                                    <i className="fa fa-comments-o" aria-hidden="true"></i>
                                                    View
                                                    <span
                                                        className="badge badge-pill badge-danger position-absolute mt--1 ml-0"
                                                    >
                                                        {item.unreadMessage}
                                                    </span>
                                                </button>
                                            )}
                                        </td>
                                        {/* <td>
                                            {
                                                usrType !== "candidate" &&
                                                <button
                                                    className="btn btn-sm btn-link p-0"
                                                    onClick={handleTimerModalShowHide}
                                                >
                                                    View
                                                </button>
                                            }

                                        </td> */}
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        {timerShowHide && <TimerPopup
            timerShowHide={timerShowHide}
            handleTimerModalShowHide={handleTimerModalShowHide}
        ></TimerPopup>}
        {msgShowHide &&
            <AppMessages
                msgShowHide={msgShowHide}
                handleMsgShowHide={handleMsgShowHide}
                currentApp={currentApp}
                workflowId={wfId}
            ></AppMessages>}
    </React.Fragment>
}
